import React, { useState } from 'react';
import '../assets/css/supplierBanner.scss';

const SupplierBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="supplier-banner">
      <div className="supplier-banner-content">
        <span className="supplier-banner-text">Vous êtes fournisseur ?</span>
        <a
          href="https://bo.marion-materiaux.com/login"
          className="supplier-banner-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          Espace fournisseur
        </a>
        <button
          className="supplier-banner-close"
          onClick={handleClose}
          aria-label="Fermer"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default SupplierBanner;